import React, {Fragment, ReactElement, ReactNode, useState} from 'react';
import {DropDownWindowProps} from "../Information/DropDown/DropDownWindow";

type NavBarItemDropDownProps = {
    icon?: ReactNode,
    text?: string,
    children: ReactElement<DropDownWindowProps> | Array<ReactElement<DropDownWindowProps>>;
}

function NavBarItemDropDown(props: NavBarItemDropDownProps) {
    const {icon, text, children} = props
    const [open, setOpen] = useState(false)

    return (
        <Fragment>
            <li className={"navbaritem-dropdown"} onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)}>
                {icon ? icon : null}
                {text ? <p>{text}</p> : null}
                <div className={"nav-dropdown-wrapper"} hidden={!open}>{children}</div>
            </li>
        </Fragment>
    )
}

export default NavBarItemDropDown;
